import PropTypes from 'prop-types'
import { Button } from '@chakra-ui/react'

export const SmallReadButton = ({ colorPalette = 'red', size = 'sm', fontSize = 'xs', fontWeight = 'normal', w = 'full', ...props }) => {
  return (
    <Button variant="solid" colorPalette={colorPalette} size={size} fontSize={fontSize} fontWeight={fontWeight} w={w} {...props}>
      読む
    </Button>
  )
}

SmallReadButton.propType = {
  colorPalette: PropTypes.string,
  size: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  w: PropTypes.string,
}
